import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { getPageSize } from '../../../../../utils'

// components
import NoteListComponent from './list/list.component'

/**
 * Contact Note Tab
 */
class ContactDetailNotes extends Component {

  /**
   * Constructor
   * @param props
   */
  constructor (props) {
    super(props)
    this.state = {
      filters: {
        limit: getPageSize('contact-note-list') || 10,
        page: 1
      }
    }
  }

  /**
   * Get contact notes based on provided filters
   * @param filters
   */
  handleFilterChange = (filters) => {
    this.setState({
      filters: { ...this.state.filters, ...filters }
    })
  }

  /**
   * Render Notes
   * @returns {*}
   */
  render () {
    const { data } = this.props
    const { filters } = this.state

    const total = data && data.length ? data.length : 0

    return (
      <NoteListComponent
        data={data}
        total={total}
        filters={filters}
        handleFilterChange={this.handleFilterChange} />
    )
  }
}

NoteListComponent.propTypes = {
  data: PropTypes.array.isRequired
}

export default ContactDetailNotes
